import React, { useContext } from 'react';
import styles from '../styles';

export interface IColor {
    color: string;
    opacity: number;
}

export interface IColorDict {
    [key: string]: IColor;
}

export interface IStyles {
    colors: IColorDict;
    breakpoints: { [key: string]: string };
    'iconography-sizes': { [key: string]: string };
    spacing: { [key: string]: string };
    typography: { [key: string]: IFont };
}

export interface IFont {
    fontFamily: string;
    fontWeight: number;
    fontSize: number;
    textAlignHorizontal: string;
    textAlignVertical: string;
    letterSpacing: number;
    lineHeightPx: number;
    lineHeightPercent: number;
    lineHeightPercentFontSize: number;
    lineHeightUnit: string;
}

// Styles is coming from a JSON, but we know the shape
// because it is created by an automated tool. So it is safe
// to do casting.
const stylesToUse = styles as any as IStyles;

interface IThemeContext {
    getFont(name: string): IFont;
    mq(property: string, name: string): string;
    styles: IStyles;
}

const getFont = (name: string): IFont => {
    const font = stylesToUse.typography[name] as IFont;

    return font;
};

const mq = (property: string, name: string): string => {
    const breakpoint = stylesToUse.breakpoints[name];
    const str = `@media (${property}: ${breakpoint})`;

    return str;
};

const ThemeContext = React.createContext({
    getFont,
    mq,
    styles: stylesToUse,
});

export const ThemeContextProvider = ({
    value,
    children,
}: {
    value: IThemeContext;
    children: any;
}) => {
    return (
        <ThemeContext.Provider value={value as any}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = (): IThemeContext => {
    const api = useContext<IThemeContext>(ThemeContext as any);
    return api;
};

export default { ThemeContextProvider, useTheme };
